const KEYS = {
  TOKEN:   'divyayoga_token',
  USER:    'divyayoga_user',
  ROLE:    'divyayoga_role',
  SESSION: 'divyayoga_session',
};

// Called after successful login   saves token, user, role, sessionToken
export const setAuth = (token, user, role, sessionToken) => {
  localStorage.setItem(KEYS.TOKEN,   token);
  localStorage.setItem(KEYS.USER,    JSON.stringify(user));
  localStorage.setItem(KEYS.ROLE,    role);
  if (sessionToken) localStorage.setItem(KEYS.SESSION, sessionToken);
};

export const getAuth = () => ({
  token:        localStorage.getItem(KEYS.TOKEN),
  user:         JSON.parse(localStorage.getItem(KEYS.USER) || 'null'),
  role:         localStorage.getItem(KEYS.ROLE),
  sessionToken: localStorage.getItem(KEYS.SESSION),
});

// Clear everything on logout
export const logout = () => {
  Object.values(KEYS).forEach(k => localStorage.removeItem(k));
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('role');
  localStorage.removeItem('session');
  localStorage.removeItem('sessionToken');
  sessionStorage.clear();
};

const normalizeRole = (role) => String(role || "").toLowerCase().replace(/[\s_-]/g, "");

const readJwtRole = () => {
  try {
    const token = localStorage.getItem(KEYS.TOKEN);
    if (!token) return "";
    const payload = token.split(".")[1];
    if (!payload) return "";
    const json = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    return json.role || json.Role || "";
  } catch {
    return "";
  }
};

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(KEYS.USER) || "null");
  } catch {
    return null;
  }
};

export const getStoredRoles = () => {
  const user = readStoredUser();
  return [
    localStorage.getItem(KEYS.ROLE),
    user?.role,
    user?.Role,
    readJwtRole(),
  ].filter(Boolean);
};

export const isAuthenticated = () => !!localStorage.getItem(KEYS.TOKEN);
export const isAdmin = () => {
  return getStoredRoles().some((role) => {
    const r = normalizeRole(role);
    return r === "admin" || r === "superadmin";
  });
};

export const isSuperAdmin = () =>
  getStoredRoles().some((role) => normalizeRole(role) === "superadmin");

export const isUser          = () => localStorage.getItem(KEYS.ROLE) === 'user';